import { MaintenanceActions, MaintenanceActionTypes } from './maintenance.actions';
import { IMaintenanceState, MaintenanceState } from './maintenance-models/maintenance-state.model';

const initialMaintenanceDummyState: IMaintenanceState = new MaintenanceState();
initialMaintenanceDummyState.EmployerSearchResult = [];
export function maintenanceReducer(state: IMaintenanceState = initialMaintenanceDummyState, action: MaintenanceActions): IMaintenanceState {
switch (action.type) {
    case MaintenanceActionTypes.LoadSearchEmployerSuccess:
        return {
            ...state,
            EmployerSearchResult: action.payload
        };
    case MaintenanceActionTypes.LoadSearchEmployerFail:
        return {
            ...state,
            EmployerSearchResult: null,
            Error: action.payload
        };


default:
return state;
}
}
